export default {
  title: {
    en: 'Choose the date for your email notification:',
  },
  hint: {
    en: `
      Based on the date she will receive the email, if she redeems today, 
      her first perfume will be shipped by end of month from our facility
    `,
  },
}
